import React from 'react'
import Email from '../assets/forward.png'
import BG from '../assets/bg2.png'

function Footer() {
  return (
    <>
        <div className='bg-cover bg-center bg-opacity-30 w-full mt-20' style={{ backgroundImage: `url(${BG})` }} id='contact'>
        <div className='lg:w-2/3 sm:w-7/12 mx-auto flex py-28 sm:flex-col justify-between lg:flex-row lg:pl-32  lg:pr-24 sm:pl-0'>
        <div >
            <img src={Email} alt='' className='sm:w-16 md:w-20 lg:w-auto'>
            </img>
            <p className='font-limelight font-bold text-base mb-2 text-[#1E2F23]'>
              wangxinjie@ouc.edu.cn
            </p>
        </div>
        <div className=''>
            <p className='text-[#1E2F23] tracking-widest font-semibold py-4 w-1/3 lg:text-4xl lg:leading-loose md:text-2xl md:w-fit md:leading-loose sm:text-xl sm:w-fit sm:leading-loose lg:-indent-20'>欢迎加入图形实验室</p>
            <p className='text-[#1E2F23] tracking-widest font-semibold py-4 w-1/3 lg:text-4xl lg:leading-loose md:text-2xl md:w-fit md:leading-loose sm:text-xl sm:w-fit sm:leading-loose'>我们欢迎你的到来!</p>
        </div>
        </div>
    </div>
    <p className='font-limelight py-6 text-center'>
    © 2024 LabOfCG – All rights reserved.
    </p>
    </>
  )
}

export default Footer
